import { IEnvironment } from "./environment.interface";
import { AppConfig } from "@core/models";

export const AVAILABLE_CONFIGS: AppConfig[] = [
  {
    code: "ADL",
    defaultMail: "noreply@culturespaces.com",
    gatewayId: "6720efb8dcb90af74ba7caae",
    host: "https://vivenu.dev/api",
    currency: "EUR",
    printer: {
      available: true,
      message: "Paper near end",
    },
    salechannelId: "sch_67a323e7c58023ef0d77aca4",
    sellerId: "65fbe46cea5343ada92ee5e1",
    terminalId: "P400Plus-807337692",
    tokenKey: "key_bc8d049b1a76d1d1addb4d1c8ac1180408c20255182c620c0e84461a8ee17a63215f7f34ca796318e13fdf8f2dbc7447",
  },
  {
    code: "FC",
    defaultMail: "noreply@culturespaces.com",
    gatewayId: "67a34a55634fc82a3e73b6e0",
    host: "https://vivenu.dev/api",
    currency: "EUR",
    printer: {
      available: true,
      message: "Paper near end",
    },
    salechannelId: "sch_6877bf08c60c48d20fd5f53d",
    sellerId: "656ef22e63a2449b2e8903c9",
    terminalId: "P400Plus-807337692",
    tokenKey: "key_514e6267483afdb195b33a1efd39262757ff8565322f54528532aa563d186f4013e66b8af7ead5af2a3b7a28191874cc",
  }
];

const DEFAULT_CONFIG = AVAILABLE_CONFIGS[0];

export const environment: IEnvironment = {
  production: false,
  env: 'DEV',
  splashScreen: true,
  apiUrl: DEFAULT_CONFIG.host,
  apiSettings: DEFAULT_CONFIG,
  loggerApiUrl: "https://api-dev-na.guestup.com/go-onsite-logger/v1",
  localServerUrl: "http://localhost:8081",
};
